// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-shadow[data-v-dd0104c6]{border:2px solid rgba(255,0,0,.35)}.make-red[data-v-dd0104c6]{color:red}.save-button[data-v-dd0104c6]{background-color:#4abca5;color:#fff}.flex-d[data-v-dd0104c6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}", ""]);
// Exports
module.exports = exports;
